<script>
import Layout from "../../layouts/main"
import Style from "@/views/layouts/style"
import PageHeader from "@/components/Page-header"
import appConfig from "../../../../app.config"
import sg_sstAPI from "../../../services/sg-sst/sg_sstAPI"
import EmployeeAPI from "../../../services/employee/employeeAPI"
import UserSSOAPI from "../../../services/sso/users/userSSOAPI"
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file"
import Swal from "sweetalert2"
import { required } from "vuelidate/lib/validators"
import CompanyItemsAPI from "@/services/items/companies_itemsAPI"
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import { sendNotification } from "@/utils/helpers/notification"
import CheckModal from "@/components/CheckModal"
import ItemAPI from "@/services/items/itemsAPI";
import DocumentActions from "@/components/document/DocumentActions.vue";

export default {
  page: {
    title: "Responsable del SG SST",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    DocumentActions,
  },
  data() {
    return {
      title: "1.1.1 Responsable del SG SST",
      items: [{
        text: 'Estándares',
        href: '/forms/estandares',
      },
      {
        text: 'Responsable del SG SST',
        active: true,
      },
      ],

      checked: true,
      checked2: false,
      status: "accepted",
      status2: "not_accepted",
      selected: "B",
      awesome: true,
      list: [],

      sg_sstData: {
        id: null,
        id_diseno_sso: null,
        employee: null,
        appointment_date: null,
        withdrawal_date: null,
        status: 1,
        company_name: null,
        course_start_date: null,
        certificate: null,
        professional_name: null,
        professional_license_number: null,
        professional_license: null,
        professional_course_50h_certificate: null,
        professional_course_50h_date: null,
        professional_course_20h_certificate: null,
        professional_course_20h_date: null,
        course_20h_certificate: null,
        course_20h_date: null,
        designation_acta: null,
        professional_designation_acta: null,
        actas: {},
      },

      certificateExist: false,

      userSelected: null,
      usersList: [],

      submitted: false,
      file: null,
      licenseFile: null,
      course20hFile: null,
      // Actas de designación diligenciadas cargadas por la empresa (alternativa al
      // acta que la app genera y firma digitalmente mas abajo en esta misma pantalla).
      operativoActaFile: null,
      profesionalActaFile: null,
      profCourse50hFile: null,
      profCourse20hFile: null,

      employeeDesignSST: "",

      companyID: this.$store.getters["company/getCompany"].id || null,
      company: this.$store.getters["company/getCompany"] || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

      loading: true,
      loading2: true,

      itemData: null,

      item1: null,
      itemStatus1: null,

      item11: null,
      itemStatus11: null,
    }
  },
  validations: {
    sg_sstData: {
      employee: {
        required
      },
      appointment_date: {
        required
      }
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(1)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    getRole(name, roles) {
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null
      if (role) {
        if (roles) {
          role = roles.includes(role) ? true : false
        }
        else {
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8
        }
        const permissions = this.$store.state.auth.info.permissions
        const enabled = permissions.find(permission => permission.name === name)
        return enabled && role ? true : false
      }
      else {
        return false
      }
    },

    changeStatusValue() {
      this.sg_sstData.status = this.sg_sstData.status === 1 ? 0 : 1
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 1)
        .then(response => {
          this.item1 = response || null
          this.itemStatus1 = response.status
        })
        .catch(error => {
          console.log(error)
        })
      CompanyItemsAPI.getStatus(this.companyID, 11)
        .then(response => {
          this.item11 = response || null
          this.itemStatus11 = response.status
        })
        .catch(error => {
          console.log(error)
        })
      this.loading2 = false
    },

    print() {
      if (this.sg_sstData.certificate) {
        window.location.href = this.sg_sstData.certificate
      }
    },

    getFile(file) {
      if (!file) return "";
      const name = file.split("/");
      return name[name.length - 1];
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        // Sin archivo nuevo no hay nada que subir: se conserva el certificado
        // actual (que puede ser null si el responsable aun no lo cargo).
        if (this.file === null) {
          return true;
        }

        const name = this.file.name;
        const env = process.env.VUE_APP_ENV === 'development' ? 'sst-dev' : 'sst-prod';
        const url = `${env}/${this.company.nit}/1.1.1/${this.$route.params.id}/${name}`;

        const result = await uploadDocument(url, this.file);
        if (!result) return false;

        this.sg_sstData.certificate = `${process.env.VUE_APP_BUCKET}/${url}`;
        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * Sube un archivo al bucket bajo la carpeta del ítem 1.1.1 y devuelve la URL pública.
     */
    async uploadToBucket(file, filename) {
      const env = process.env.VUE_APP_ENV === 'development' ? 'sst-dev' : 'sst-prod';
      const path = `${env}/${this.company.nit}/1.1.1/${this.$route.params.id}/${filename}`;
      const ok = await uploadDocument(path, file);
      return ok ? `${process.env.VUE_APP_BUCKET}/${path}` : null;
    },

    /**
     * Sube los documentos externos del profesional (licencia) y el certificado de 20h.
     */
    async uploadExtraDocs() {
      try {
        if (this.licenseFile) {
          const url = await this.uploadToBucket(this.licenseFile, `licencia-${this.licenseFile.name}`);
          if (url) this.sg_sstData.professional_license = url;
        }
        if (this.course20hFile) {
          const url = await this.uploadToBucket(this.course20hFile, `op-curso20h-${this.course20hFile.name}`);
          if (url) this.sg_sstData.course_20h_certificate = url;
        }
        if (this.operativoActaFile) {
          const url = await this.uploadToBucket(this.operativoActaFile, `acta-operativo-${this.operativoActaFile.name}`);
          if (url) this.sg_sstData.designation_acta = url;
        }
        if (this.profesionalActaFile) {
          const url = await this.uploadToBucket(this.profesionalActaFile, `acta-profesional-${this.profesionalActaFile.name}`);
          if (url) this.sg_sstData.professional_designation_acta = url;
        }
        if (this.profCourse50hFile) {
          const url = await this.uploadToBucket(this.profCourse50hFile, `prof-curso50h-${this.profCourse50hFile.name}`);
          if (url) this.sg_sstData.professional_course_50h_certificate = url;
        }
        if (this.profCourse20hFile) {
          const url = await this.uploadToBucket(this.profCourse20hFile, `prof-curso20h-${this.profCourse20hFile.name}`);
          if (url) this.sg_sstData.professional_course_20h_certificate = url;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async update() {
      try {
        this.submitted = true
        this.loading2 = true
        // Snapshot del profesional + carga de licencia y certificado de 20h
        this.sg_sstData.professional_name = this.employeeDesignSST
          ? (this.employeeDesignSST.name || this.employeeDesignSST.full_name || null)
          : null;
        let response = await this.uploadDocument();
        await this.uploadExtraDocs();

        if (!response) {
          this.loading2 = false;
          Swal.fire({
            title: "¡ERROR!",
            text: "No se pudo subir el certificado. Revisa el archivo e intenta de nuevo.",
            icon: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          return;
        }

        // El <select> guarda el ID del empleado, no el objeto: hay que resolverlo
        // contra usersList antes de usarlo (antes se leia .id sobre un numero y
        // employee_id viajaba como undefined).
        const employeeId = this.sg_sstData.employee;
        const employeeObj = this.usersList.find((u) => u.id === employeeId);

        if (!employeeId || !employeeObj || !this.employeeDesignSST) {
          this.loading2 = false;
          Swal.fire({
            title: "Faltan datos",
            text: !this.employeeDesignSST
              ? "No se pudo identificar al profesional responsable del SG-SST."
              : "Selecciona un responsable operativo válido.",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          return;
        }

        {
          let data = {
            id: this.sg_sstData.id,
            employee_id: employeeId,
            id_diseno_sso: this.employeeDesignSST.id,
            appointment_date: this.sg_sstData.appointment_date,
            withdrawal_date: this.sg_sstData.withdrawal_date,
            status: this.sg_sstData.status,
            company_name: this.sg_sstData.company_name,
            course_start_date: this.sg_sstData.course_start_date,
            certificate: this.sg_sstData.certificate,
            professional_name: this.sg_sstData.professional_name,
            professional_license_number: this.sg_sstData.professional_license_number,
            professional_license: this.sg_sstData.professional_license,
            professional_course_50h_certificate: this.sg_sstData.professional_course_50h_certificate,
            professional_course_50h_date: this.sg_sstData.professional_course_50h_date,
            professional_course_20h_certificate: this.sg_sstData.professional_course_20h_certificate,
            professional_course_20h_date: this.sg_sstData.professional_course_20h_date,
            course_20h_certificate: this.sg_sstData.course_20h_certificate,
            course_20h_date: this.sg_sstData.course_20h_date,
            designation_acta: this.sg_sstData.designation_acta,
            professional_designation_acta: this.sg_sstData.professional_designation_acta,
          }
          sg_sstAPI.updateSg_sst(this.sg_sstData.id, data)
            .then(response => {
              employeeObj.implementation_status = 1
              EmployeeAPI.updateEmployee(employeeObj)
                .then(res => {
                  const itemChange11 = {
                    companies_id: this.companyID,
                    item_id: 1,
                    status: 'Pendiente',
                  };
                  newScoresAPI.calculateScores(itemChange11)
                    .then((response) => {
                      const itemChange41 = {
                        companies_id: this.companyID,
                        item_id: 11,
                        status: 'Pendiente',
                      };
                      newScoresAPI.calculateScores(itemChange41)
                        .then((response) => {
                          this.sendNotification(1, 1, true);
                          this.sendNotification(1, 1, false);
                          this.loading2 = false
                          setTimeout(() => {
                            Swal.fire({
                              title: "¡Éxito!",
                              text: "¡Se ha registrado con éxito!",
                              type: "success",
                              icon: "success",
                              confirmButtonClass: "btn btn-confirm mt-2",
                            });
                            this.$router.go(-1);
                          }, 2000)
                        })
                        .catch((error) => {
                          Swal.fire({
                            title: "¡ERROR!",
                            text: "¡No se ha actualizado el estado del ítem!",
                            icon: "error",
                            type: "error",
                            confirmButtonClass: "btn btn-confirm mt-2",
                          });
                          setTimeout(() => window.location.reload(), 2000)
                          console.log(error);
                        });
                    })
                    .catch((error) => {
                      Swal.fire({
                        title: "¡ERROR!",
                        text: "¡No se ha actualizado el estado del ítem!",
                        icon: "error",
                        type: "error",
                        confirmButtonClass: "btn btn-confirm mt-2",
                      });
                      setTimeout(() => window.location.reload(), 2000)
                      console.log(error);
                    });
                })
                .catch(error => {
                  console.log(error)
                })
            })
            .catch((error) => {
              this.loading2 = false
              console.log(error)
              Swal.fire({
                title: "Error",
                text: "No se ha podido actualizar",
                type: "warning",
                icon: "warning",
                confirmButtonClass: "btn btn-confirm mt-2",
              })
            })
        }
      } catch (error) {
        // Sin esto, cualquier excepcion dejaba loading2 en true y el formulario
        // se quedaba cargando para siempre, sin decirle nada al usuario.
        this.loading2 = false
        console.log(error)
        Swal.fire({
          title: "Error",
          text: "No se ha podido actualizar",
          icon: "error",
          confirmButtonClass: "btn btn-confirm mt-2",
        })
      }
    },

    async getData() {
      try {
        const response = await sg_sstAPI.getSSSSTbyID(this.$route.params.id);
        this.sg_sstData = response['SGSST-list:'];
        const { employee } = await EmployeeAPI.getAll(this.companyID);
        const list = employee.filter(item => item.id_implementation_sso);
        this.usersList = list || null;
        // Aquí se asigna el empleado encontrado
        const emp = this.usersList.find(user => user.id === this.sg_sstData.employee_id);
        this.sg_sstData.employee = emp ? emp.id : null;
        if (this.sg_sstData.certificate) {
          this.certificateExist = true;
        }
        const { data } = await UserSSOAPI.getAllAdmin();
        const users = data;
        if (users && users.length > 0) {
          let designUser = users.find(item => item.id == this.company.id_diseno_sso);
          this.employeeDesignSST = designUser;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    goBack() {
      this.$router.go(-1)
    },

    actaStatus(type) {
      const actas = this.sg_sstData && this.sg_sstData.actas
      return (actas && actas[type] && actas[type].status) || 'draft'
    },

    actaSignedAt(type) {
      const actas = this.sg_sstData && this.sg_sstData.actas
      return (actas && actas[type] && actas[type].signed_at) || null
    },

    onActaSigned(type, payload) {
      if (!this.sg_sstData.actas) this.$set(this.sg_sstData, 'actas', {})
      this.$set(this.sg_sstData.actas, type, { status: 'signed', signed_at: payload.signed_at })
    },
  },

  computed: {
    // Bloquea la edición si CUALQUIERA de las dos actas ya fue firmada
    isSigned() {
      return this.actaStatus('responsable-sg') === 'signed'
        || this.actaStatus('responsable-operativo') === 'signed'
    },
    // Wrappers por tipo de acta para reutilizar el componente DocumentActions sin romper su firma
    responsableActaAPI() {
      return {
        pdfUrl: (id) => sg_sstAPI.pdfUrl(id, 'responsable-sg'),
        sign: (id, payload) => sg_sstAPI.sign(id, 'responsable-sg', payload),
      }
    },
    operativoActaAPI() {
      return {
        pdfUrl: (id) => sg_sstAPI.pdfUrl(id, 'responsable-operativo'),
        sign: (id, payload) => sg_sstAPI.sign(id, 'responsable-operativo', payload),
      }
    },
  },

  mounted() {
    this.getData()
    this.getItems()
    this.getItemData()
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-9">

        <div v-if="!loading && !loading2 && classificationID <= 4">
          <div class="card">
            <div class="card-body">
              <div class="row">

                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">Como responsable del SG-SST van a existir dos roles:</p>
                    <p class="text-justify">
                      <b>Profesional Responsable del SG-SST:</b> Se nombrará por parte de Emisión, será el encargado de guiar todo el
                      proceso de diseño de la implementación de SG-SST.
                    </p>
                    <p class="text-justify">
                      <b>Responsable operativo del SG-SST:</b> Persona por parte de la Empresa que será la encargada de
                      llevar a cabo las actividades correspondientes, recopilar las evidencias y alimentar el sistema
                      con estos
                      archivos para poder hacer seguimiento a las actividades de implementación por parte del
                      Profesional Responsable del SG-SST.
                    </p>
                    <hr />
                    <p class="text-justify"><b>Funciones:</b></p>
                    <p class="text-justify">
                    <ol>
                      <li>Planificar, dirigir, ejecutar y aplicar el SG-SST.</li>
                      <li>Informar a la gerencia sobre el funcionamiento y resultados del SG-SST.</li>
                      <li>Promover la participación de los miembros de la empresa en la implementación del SG-SST.</li>
                      <li>Promover la comprensión de la política en todas las áreas de la empresa.</li>
                      <li>Coordinar las capacitaciones necesarias en materia de prevención.</li>
                      <li>Apoyar la investigación de accidentes de trabajo.</li>
                      <li>Apoyar las reuniones de los diferentes comités conformados.</li>
                      <li>Implementación, seguimiento y control del SG-SST.</li>
                    </ol>
                    </p>
                  </CheckModal>
                </div>

              </div>
              <form>
                <div class="form-row pt-3">
                  <b-form-group class="col-md-6 px-2" label="Profesional Responsable del SG-SST" label-for="designResponsible">
                    <b-form-input type="text" id="designResponsible" placeholder="" v-model="employeeDesignSST.name"
                      disabled></b-form-input>
                  </b-form-group>
                  <b-form-group id="responsibleSST" label-for="responsibleSST" class="col-md-6 px-2"
                    label="Responsable operativo del SG-SST">
                    <select class="form-control" v-model="sg_sstData.employee" :disabled="!getRole('Editar', [1, 4])"
                      :class="{ 'is-invalid': $v.sg_sstData.employee.$error && submitted }">
                      <b-form-select-option v-for="user in usersList" :key="user.id" :value="user.id">{{
                        user.full_name}}</b-form-select-option>
                    </select>
                    <a id="responsibleSSTText" underline href="/forms/sg-sst"><small>¿Quién es el responsable operativo?</small></a>
                    <div v-if="submitted && $v.sg_sstData.employee.$error">
                      <small v-if="!$v.sg_sstData.employee.required" class="text-danger"><b>El responsable operativo del SG-SST es requerido</b></small>
                    </div>
                  </b-form-group>
                </div>

                <div class="form-row">
                  <b-form-group class="col-md-6 px-2" label="Fecha nombramiento" label-for="appointmentDate">
                    <b-form-input
                      :disabled="!getRole('Editar', [1, 4]) || !getRole('Asignar responsable de implemenación', [1, 4]) || !allowAccess()"
                      type="date" id="appointmentDate" v-model="sg_sstData.appointment_date"
                      :class="{ 'is-invalid': $v.sg_sstData.appointment_date.$error && submitted }">
                    </b-form-input>
                    <div v-if="submitted && $v.sg_sstData.appointment_date.$error">
                      <small v-if="!$v.sg_sstData.appointment_date.required" class="text-danger"><b>La fecha de nombramiento es requerida</b></small>
                    </div>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Fecha retiro" label-for="withdrawalDate">
                    <b-form-input
                      :disabled="!getRole('Editar', [1, 4]) || !getRole('Asignar responsable de implemenación', [1, 4]) || !allowAccess()"
                      type="date" id="withdrawalDate" v-model="sg_sstData.withdrawal_date">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="row px-2">
                  <div class="col-md-2 col-sm-12">
                    <div class="form-row m-0">
                      <b-form-group class="pt-3 mb-0" label="¿El operativo tiene el curso de 50 horas?" label-for="course50">
                      </b-form-group>
                      <b-form-group class="col-sm-12" label-for="course">
                        <a id="course" underline href="/forms/curso#list-item-2"><small>¿Dónde puedo hacer el curso?</small></a>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="form-row">
                      <b-form inline class="pt-3 float-left">
                        <label class="mr-2">Si</label>
                        <input
                          :disabled="!getRole('Editar', [1, 4]) || !getRole('Asignar responsable de implemenación', [1, 4]) || !allowAccess()"
                          type="radio" style="color: #666" @click="changeStatusValue" v-model="sg_sstData.status"
                          :value="1" class="mb-2 mr-sm-2 mb-sm-0" label="Si" />
                        <label class="mr-2">No</label>
                        <input
                          :disabled="!getRole('Editar', [1, 4]) || !getRole('Asignar responsable de implemenación', [1, 4]) || !allowAccess()"
                          type="radio" @click="changeStatusValue" v-model="sg_sstData.status" :value="0"
                          class="mb-2 mr-sm-2 mb-sm-0" label="No" />
                      </b-form>
                    </div>
                  </div>
                  <div class="col-6 pt-1"></div>
                </div>

                <div class="form-row pt-1" v-if="sg_sstData.status">
                  <div class="col-md-4 col-sm-12 px-2">
                    <b-form-group label="Fecha" label-for="dateCourse">
                      <b-form-input
                        :disabled="!getRole('Editar', [1, 4]) || !getRole('Asignar responsable de implemenación', [1, 4]) || !allowAccess()"
                        required type="date" id="courseStartDate" v-model="sg_sstData.course_start_date">
                      </b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-md-4 col-sm-12 px-2">
                    <b-form-group label="Entidad certificadora" label-for="companyName">
                      <b-form-input
                        :disabled="!getRole('Editar', [1, 4]) || !getRole('Asignar responsable de implemenación', [1, 4]) || !allowAccess()"
                        required type="text" placeholder="Entidad certificadora" id="companyName"
                        v-model="sg_sstData.company_name">
                      </b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-md-4 col-lg-3 col-sm-10 px-2">
                    <b-form-group label="Certificado" label-for="file">
                      <b-form-file
                        :disabled="!getRole('Editar', [1, 4]) || !getRole('Asignar responsable de implemenación', [1, 4]) || !allowAccess()"
                        type="file" id="file" ref="file" name="file" browse-text="Buscar"
                        :placeholder="sg_sstData.certificate ? getFile(sg_sstData.certificate) : `Selecciona un archivo...`"
                        drop-placeholder="Suelta acá..." required v-model="file" @change="uploadFile"
                        v-on:change="uploadFile"
                        accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                      </b-form-file>
                    </b-form-group>
                  </div>

                  <div class="col-lg-1 col-sm-2 px-2">
                    <b-form-group label="Descargar" label-for="file">
                      <button :disabled="!getRole('Consultar') || !certificateExist || !allowAccess()" type="button"
                        id="downloadCertificate"
                        :class="`btn ${certificateExist ? 'btn-outline-primary' : 'btn-secondary'} btn-md`"
                        @click="print()"><i class="bx bx-download"></i>
                      </button>
                      <b-tooltip target="downloadCertificate">
                        {{ certificateExist ? 'Descargar certificado' : 'No se ha subido un certificado aún' }}
                      </b-tooltip>
                    </b-form-group>
                  </div>
                </div>

                <hr />
                <h6 class="pl-2 mb-2 font-weight-bold">Responsable Operativo — Curso 20 horas</h6>
                <div class="form-row pt-1">
                  <div class="col-md-3 col-sm-12 px-2">
                    <b-form-group label="Acta de designación diligenciada" label-for="opActaFile">
                      <b-form-file
                        :disabled="!getRole('Editar', [1, 4]) || !getRole('Asignar responsable de implemenación', [1, 4]) || !allowAccess() || isSigned"
                        id="opActaFile" ref="operativoActaFile" browse-text="Buscar" v-model="operativoActaFile"
                        :placeholder="sg_sstData.designation_acta ? getFile(sg_sstData.designation_acta) : 'Selecciona un archivo...'"
                        drop-placeholder="Suelta acá..." accept=".pdf,.doc,.docx,.jpg,.jpeg,.png">
                      </b-form-file>
                      <a v-if="sg_sstData.designation_acta" :href="sg_sstData.designation_acta" target="_blank">
                        <small>Ver acta cargada</small>
                      </a>
                    </b-form-group>
                  </div>
                  <div class="col-md-3 col-sm-12 px-2">
                    <b-form-group label="Fecha curso 20 horas" label-for="opCourse20hDate">
                      <b-form-input
                        :disabled="!getRole('Editar', [1, 4]) || !getRole('Asignar responsable de implemenación', [1, 4]) || !allowAccess() || isSigned"
                        type="date" id="opCourse20hDate" v-model="sg_sstData.course_20h_date">
                      </b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-3 col-sm-12 px-2">
                    <b-form-group label="Certificado curso 20 horas" label-for="opCourse20hFile">
                      <b-form-file
                        :disabled="!getRole('Editar', [1, 4]) || !getRole('Asignar responsable de implemenación', [1, 4]) || !allowAccess() || isSigned"
                        id="opCourse20hFile" ref="course20hFile" browse-text="Buscar" v-model="course20hFile"
                        :placeholder="sg_sstData.course_20h_certificate ? getFile(sg_sstData.course_20h_certificate) : 'Selecciona un archivo...'"
                        drop-placeholder="Suelta acá..." accept=".pdf,.doc,.docx,.jpg,.jpeg,.png">
                      </b-form-file>
                      <a v-if="sg_sstData.course_20h_certificate" :href="sg_sstData.course_20h_certificate" target="_blank">
                        <small>Ver certificado cargado</small>
                      </a>
                    </b-form-group>
                  </div>
                </div>

                <h6 class="pl-2 mb-2 mt-2 font-weight-bold">Profesional Responsable del SG-SST</h6>
                <div class="form-row pt-1">
                  <div class="col-md-3 col-sm-12 px-2">
                    <b-form-group label="Acta de designación diligenciada" label-for="profActaFile">
                      <b-form-file
                        :disabled="!getRole('Editar', [1, 4]) || !getRole('Asignar responsable de implemenación', [1, 4]) || !allowAccess() || isSigned"
                        id="profActaFile" ref="profesionalActaFile" browse-text="Buscar" v-model="profesionalActaFile"
                        :placeholder="sg_sstData.professional_designation_acta ? getFile(sg_sstData.professional_designation_acta) : 'Selecciona un archivo...'"
                        drop-placeholder="Suelta acá..." accept=".pdf,.doc,.docx,.jpg,.jpeg,.png">
                      </b-form-file>
                      <a v-if="sg_sstData.professional_designation_acta" :href="sg_sstData.professional_designation_acta" target="_blank">
                        <small>Ver acta cargada</small>
                      </a>
                    </b-form-group>
                  </div>
                  <div class="col-md-3 col-sm-12 px-2">
                    <b-form-group label="Licencia en SST N.°" label-for="licenseNumber">
                      <b-form-input
                        :disabled="!getRole('Editar', [1, 4]) || !getRole('Asignar responsable de implemenación', [1, 4]) || !allowAccess() || isSigned"
                        type="text" id="licenseNumber" placeholder="N.° de licencia"
                        v-model="sg_sstData.professional_license_number">
                      </b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-3 col-sm-12 px-2">
                    <b-form-group label="Licencia (archivo)" label-for="licenseFile">
                      <b-form-file
                        :disabled="!getRole('Editar', [1, 4]) || !getRole('Asignar responsable de implemenación', [1, 4]) || !allowAccess() || isSigned"
                        id="licenseFile" ref="licenseFile" browse-text="Buscar" v-model="licenseFile"
                        :placeholder="sg_sstData.professional_license ? getFile(sg_sstData.professional_license) : 'Selecciona un archivo...'"
                        drop-placeholder="Suelta acá..." accept=".pdf,.doc,.docx,.jpg,.jpeg,.png">
                      </b-form-file>
                      <a v-if="sg_sstData.professional_license" :href="sg_sstData.professional_license" target="_blank">
                        <small>Ver licencia cargada</small>
                      </a>
                    </b-form-group>
                  </div>
                </div>
                <div class="form-row pt-1">
                  <div class="col-md-3 col-sm-12 px-2">
                    <b-form-group label="Fecha curso 50 horas" label-for="profCourse50hDate">
                      <b-form-input
                        :disabled="!getRole('Editar', [1, 4]) || !getRole('Asignar responsable de implemenación', [1, 4]) || !allowAccess() || isSigned"
                        type="date" id="profCourse50hDate" v-model="sg_sstData.professional_course_50h_date">
                      </b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-3 col-sm-12 px-2">
                    <b-form-group label="Certificado curso 50 horas" label-for="profCourse50hFile">
                      <b-form-file
                        :disabled="!getRole('Editar', [1, 4]) || !getRole('Asignar responsable de implemenación', [1, 4]) || !allowAccess() || isSigned"
                        id="profCourse50hFile" ref="profCourse50hFile" browse-text="Buscar" v-model="profCourse50hFile"
                        :placeholder="sg_sstData.professional_course_50h_certificate ? getFile(sg_sstData.professional_course_50h_certificate) : 'Selecciona un archivo...'"
                        drop-placeholder="Suelta acá..." accept=".pdf,.doc,.docx,.jpg,.jpeg,.png">
                      </b-form-file>
                      <a v-if="sg_sstData.professional_course_50h_certificate" :href="sg_sstData.professional_course_50h_certificate" target="_blank">
                        <small>Ver certificado cargado</small>
                      </a>
                    </b-form-group>
                  </div>
                  <div class="col-md-3 col-sm-12 px-2">
                    <b-form-group label="Fecha curso 20 horas" label-for="profCourse20hDate">
                      <b-form-input
                        :disabled="!getRole('Editar', [1, 4]) || !getRole('Asignar responsable de implemenación', [1, 4]) || !allowAccess() || isSigned"
                        type="date" id="profCourse20hDate" v-model="sg_sstData.professional_course_20h_date">
                      </b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-md-3 col-sm-12 px-2">
                    <b-form-group label="Certificado curso 20 horas" label-for="profCourse20hFile">
                      <b-form-file
                        :disabled="!getRole('Editar', [1, 4]) || !getRole('Asignar responsable de implemenación', [1, 4]) || !allowAccess() || isSigned"
                        id="profCourse20hFile" ref="profCourse20hFile" browse-text="Buscar" v-model="profCourse20hFile"
                        :placeholder="sg_sstData.professional_course_20h_certificate ? getFile(sg_sstData.professional_course_20h_certificate) : 'Selecciona un archivo...'"
                        drop-placeholder="Suelta acá..." accept=".pdf,.doc,.docx,.jpg,.jpeg,.png">
                      </b-form-file>
                      <a v-if="sg_sstData.professional_course_20h_certificate" :href="sg_sstData.professional_course_20h_certificate" target="_blank">
                        <small>Ver certificado cargado</small>
                      </a>
                    </b-form-group>
                  </div>
                </div>

                <div class="form-group text-right m-b-0">
                  <div v-if="isSigned" class="alert alert-success py-2 mb-2 small">
                    🔒 Un acta ya fue firmada; los datos quedan bloqueados para edición.
                  </div>
                  <button :disabled="submitted || isSigned" type="submit" class="btn btn-primary" @click="update">Guardar</button>
                  <button type="button" @click="goBack" class="btn btn-secondary mx-1">Cancelar</button>
                </div>

              </form>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="text-center"><b-spinner variant="primary" label="Loading..."></b-spinner></div>
        </div>
      </div>

      <div class="col-md-3" v-if="!loading && !loading2 && sg_sstData.id && companyID">
        <h6 class="text-muted small mb-1">Acta Responsable SG-SST</h6>
        <DocumentActions
          :document-id="sg_sstData.id"
          :company-id="companyID"
          :workflow-status="actaStatus('responsable-sg')"
          :signed-at="actaSignedAt('responsable-sg')"
          :api-service="responsableActaAPI"
          document-title="Acta Designación Responsable SG-SST"
          signer-role="gerente"
          @signed="(p) => onActaSigned('responsable-sg', p)"
        />

        <h6 class="text-muted small mb-1 mt-3">Acta Responsable Operativo</h6>
        <DocumentActions
          :document-id="sg_sstData.id"
          :company-id="companyID"
          :workflow-status="actaStatus('responsable-operativo')"
          :signed-at="actaSignedAt('responsable-operativo')"
          :api-service="operativoActaAPI"
          document-title="Acta Designación Responsable Operativo"
          signer-role="gerente"
          @signed="(p) => onActaSigned('responsable-operativo', p)"
        />
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>